import React from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

interface ItemActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  position?: "top-right" | "center-right";
}

export default function ItemActions({
  onEdit,
  onDelete,
  position = "top-right",
}: ItemActionsProps) {
  const positionClasses =
    position === "top-right"
      ? "top-2 right-2"
      : "top-1/2 right-2 -translate-y-1/2";

  return (
    <div
      className={`absolute ${positionClasses} opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity flex gap-1`}
    >
      <button
        onClick={onEdit}
        className="p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
        title="Edit"
      >
        <PencilIcon className="w-4 h-4" />
      </button>
      <button
        onClick={onDelete}
        className="p-1.5 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
        title="Delete"
      >
        <TrashIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
